"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HIGH_FREQUENCY_LIMIT = exports.LOW_FREQUENCY_LIMIT = void 0; // frequency interval to show in Hz

exports.LOW_FREQUENCY_LIMIT = 20;
exports.HIGH_FREQUENCY_LIMIT = 20000;